/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { UiModalOptions } from "../../modal.models";
import { NzModalCloseComponent } from "ng-zorro-antd/modal";
import { TransformModalOptions } from "@webapp/ui/modal/utils/modal.utils";

@Component({
  selector: "button[ui-modal-close]",
  exportAs: "UiModalCloseBuiltin",
  templateUrl: "modal-close.component.html",
  host: {
    class: "ant-modal-close",
    "aria-label": "Close",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiModalCloseComponent extends NzModalCloseComponent {
  constructor(public modalConfig: UiModalOptions) {
    super(TransformModalOptions(modalConfig));
  }
}
